import { get, post } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'client-support-plan-revisions';
const apiClientSupportPlans = 'DEPRECATED/api/clients/support-plans';

const config = [
  {
    actionType: 'getAll',
    apiPath: (params: Params) => `${apiClientSupportPlans}/${params.plan_id}/revisions`,
    method: get,
  },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiClientSupportPlans}/revisions/${params.id}`, method: get },
  {
    actionType: 'create',
    apiPath: (params: Params) => `${apiClientSupportPlans}/${params.plan_id}/revisions`,
    method: post,
  },
];

export const { getAll, getOne, create } = createThunks(typePrefix, config);
